export default __webpack_public_path__ + "static/media/misc-closetC-2048w.6cdc6b60.avif";